// Room 3's folder lists (ai_app_backend plan task r3-folders; card R3-40), through the doorway in the `create` area,
// switched with the Create page's pictures (`v2_room3_pictures`): the names of the person's own public or private
// folders, as v1's /api/get_unique_folders and /api/get_unique_folders_private answer them, `{ folders }`, asked by the
// profile and the Create page's folder pickers. With the area off, each sends exactly the request it sent before.
// On v2: `GET /v2/me/folders` (folders-v2.ts). Moving pictures to a folder and renaming one (v1's /api/update_folder
// and /api/rename_folder, the same filing on v2): `PATCH /v2/me/folders`, answered as v1's `{ status, message }`.
import { call, lazySide } from './doorway.ts'

const AREA = 'create'

const PATHS = {
  public: '/api/get_unique_folders',
  private: '/api/get_unique_folders_private',
} as const

/** The person's own folders of their published (`public`) or private items: v1's `{ folders }`, sorted by v1. */
export const myFolders = (token: string, which: 'public' | 'private') =>
  call(
    AREA,
    PATHS[which],
    { method: 'GET', headers: { Authorization: token } },
    {
      token,
      side: lazySide(
        () => import('./folders-v2.ts'),
        (loaded) => (t, init) => loaded.myFolders(t, init, which),
        PATHS[which],
      ),
    },
  )

/**
 * Files the person's pictures and clips in a folder: `move` (v1's /api/update_folder, `{ images, folder }`) or `rename`
 * (v1's /api/rename_folder, `{ images, newName }`, the folder's items with its new name). v1's `{ status, message }`;
 * a refusal as it came (v1's 300 for a refused name, v2's 422).
 */
export const fileInFolder = (
  token: string,
  how: 'move' | 'rename',
  images: string[],
  folder: string,
) => {
  const path = how === 'move' ? '/api/update_folder' : '/api/rename_folder'
  return call(
    AREA,
    path,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: token },
      body: JSON.stringify(
        how === 'move' ? { images, folder } : { images, newName: folder },
      ),
    },
    {
      token,
      side: lazySide(
        () => import('./folders-v2.ts'),
        (loaded) => (t, init) =>
          loaded.fileInFolder(t, init, how, images, folder),
        path,
      ),
    },
  )
}
